"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils/utils");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StructuralGrid = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
`;
const ImageWrapper = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  height: 168px;
  margin-bottom: 48px;
`;
const HeadingWrapper = _styledComponents.default.div`
  text-align: center;
  margin-bottom: 24px;
`;
const DescriptionWrapper = _styledComponents.default.div`
  text-align: center;
  margin-bottom: 48px;
`;
const ButtonContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: var(--Spacing-spacing-06, 24px);
  ${_r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)`
      flex-direction: row-reverse;
    `)}
  ${_r10SourceLibrary.Mixins.respondTo.lg((0, _styledComponents.css)`
      width: 80%;
      align-self: center;
    `)}
`;
const ButtonItem = _styledComponents.default.div`
  flex: 1;
  ${_r10SourceLibrary.Mixins.respondTo.lg(`max-width:300px;`)}
`;
const EntelDynamicMessageTemplate = _ref => {
  var _buttonTheme$appearan, _buttonTheme$appearan2;
  let {
    imagePath,
    translationKeys,
    containerTestId,
    buttons
  } = _ref;
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const buttonTheme = (0, _useLocalTheme.default)('button');
  return /*#__PURE__*/_react.default.createElement("div", {
    id: containerTestId
  }, /*#__PURE__*/_react.default.createElement(StructuralGrid, null, /*#__PURE__*/_react.default.createElement(ImageWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Image, {
    sm: {
      src: (0, _utils.getImagePath)(imagePath),
      height: '168px',
      width: '168px'
    }
  })), /*#__PURE__*/_react.default.createElement(HeadingWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    weight: 2,
    size: 3,
    dataAttributes: {
      'data-test-id': translationKeys.titleTestId
    }
  }, _services.locale.localeString(translationKeys.heading))), /*#__PURE__*/_react.default.createElement(DescriptionWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    justify: "center",
    weight: 2,
    dataAttributes: {
      'data-test-id': translationKeys.subtitleTestId
    }
  }, translationKeys.message)), /*#__PURE__*/_react.default.createElement(ButtonContainer, null, /*#__PURE__*/_react.default.createElement(ButtonItem, {
    isMdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan = buttonTheme.appearance) === null || _buttonTheme$appearan === void 0 ? void 0 : _buttonTheme$appearan.primary,
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    state: buttons.primary.state || '',
    width: "full",
    text: _services.locale.localeString(buttons.primary.translationKey),
    onClick: () => buttons.primary.onClick(),
    dataAttributes: {
      'data-test-id': buttons.primary.buttonTestId
    }
  }))), /*#__PURE__*/_react.default.createElement(ButtonItem, {
    isMdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.HoverDisableWrapper, {
    theme: buttonTheme === null || buttonTheme === void 0 ? void 0 : (_buttonTheme$appearan2 = buttonTheme.appearance) === null || _buttonTheme$appearan2 === void 0 ? void 0 : _buttonTheme$appearan2.alt1,
    mdAndBelow: breakpoints.mdAndBelow
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    state: buttons.secondary.state || '',
    width: "full",
    appearance: "alt1",
    text: _services.locale.localeString(buttons.secondary.translationKey),
    onClick: () => buttons.secondary.onClick(),
    dataAttributes: {
      'data-test-id': buttons.secondary.buttonTestId
    }
  }))))));
};
var _default = EntelDynamicMessageTemplate;
exports.default = _default;